import { ElementRef, EventEmitter, input, viewChild } from '@angular/core';
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { DropdownHelperService } from 'Angular/services/dropdown-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/dropdown-helper.service";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/multi-select-dropdown/multi-select-dropdown.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = ["chartOptions"];
const _c1 = a0 => ({ show: a0 });
const _c2 = () => ({ dropdownContainer: "dropdown-nested", button: "dropdown-item", dropdownItem: "pl-40" });
const _c3 = a0 => ({ "custom-checkbox-tall": a0 });
const _forTrack0 = ($index, $item) => $item.value;
function ChartOptionsComponent_For_8_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
} }
function ChartOptionsComponent_For_8_Conditional_1_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 15);
    i0.ɵɵlistener("click", function ChartOptionsComponent_For_8_Conditional_1_Conditional_5_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r5); const listItem_r4 = i0.ɵɵnextContext(2).$implicit; i0.ɵɵnextContext(); const helpModal_r6 = i0.ɵɵreference(16); helpModal_r6.openModal(listItem_r4.helpName); return i0.ɵɵresetView(false); });
    i0.ɵɵtext(3, "(?)");
    i0.ɵɵelementEnd();
} }
function ChartOptionsComponent_For_8_Conditional_1_For_8_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
} }
function ChartOptionsComponent_For_8_Conditional_1_For_8_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 16)(1, "input", 17);
    i0.ɵɵlistener("click", function ChartOptionsComponent_For_8_Conditional_1_For_8_Conditional_1_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r7); const currencyItem_r8 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.updateChartCurrency(currencyItem_r8)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 12)(3, "span", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const currencyItem_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", currencyItem_r8.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", currencyItem_r8.label);
} }
function ChartOptionsComponent_For_8_Conditional_1_For_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, ChartOptionsComponent_For_8_Conditional_1_For_8_Conditional_0_Template, 1, 0, "div", 5)(1, ChartOptionsComponent_For_8_Conditional_1_For_8_Conditional_1_Template, 4, 2, "label", 16);
} if (rf & 2) {
    const currencyItem_r8 = ctx.$implicit;
    i0.ɵɵconditional(currencyItem_r8.type === "divider" ? 0 : 1);
} }
function ChartOptionsComponent_For_8_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("mouseenter", function ChartOptionsComponent_For_8_Conditional_1_Template_div_mouseenter_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.isCurrencyMenuOpen = true); })("mouseleave", function ChartOptionsComponent_For_8_Conditional_1_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.isCurrencyMenuOpen = false); });
    i0.ɵɵelementStart(1, "label", 10)(2, "input", 11);
    i0.ɵɵlistener("change", function ChartOptionsComponent_For_8_Conditional_1_Template_input_change_2_listener() { i0.ɵɵrestoreView(_r2); const listItem_r4 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateChartOptions(listItem_r4)); });
    i0.ɵɵtwoWayListener("ngModelChange", function ChartOptionsComponent_For_8_Conditional_1_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r2); const listItem_r4 = i0.ɵɵnextContext().$implicit; i0.ɵɵtwoWayBindingSet(listItem_r4.selected, $event) || (listItem_r4.selected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 12)(4, "span", 13);
    i0.ɵɵconditionalCreate(5, ChartOptionsComponent_For_8_Conditional_1_Conditional_5_Template, 4, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 14);
    i0.ɵɵrepeaterCreate(7, ChartOptionsComponent_For_8_Conditional_1_For_8_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", listItem_r4.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", listItem_r4.label);
    i0.ɵɵadvance();
    i0.ɵɵconditional(listItem_r4.helpName ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1, ctx_r2.isCurrencyMenuOpen));
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx.list);
} }
function ChartOptionsComponent_For_8_Conditional_2_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 15);
    i0.ɵɵlistener("click", function ChartOptionsComponent_For_8_Conditional_2_Conditional_5_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r10); const listItem_r4 = i0.ɵɵnextContext(2).$implicit; i0.ɵɵnextContext(); const helpModal_r6 = i0.ɵɵreference(16); helpModal_r6.openModal(listItem_r4.helpName); return i0.ɵɵresetView(false); });
    i0.ɵɵtext(3, "(?)");
    i0.ɵɵelementEnd();
} }
function ChartOptionsComponent_For_8_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label", 18)(2, "input", 11);
    i0.ɵɵlistener("change", function ChartOptionsComponent_For_8_Conditional_2_Template_input_change_2_listener() { i0.ɵɵrestoreView(_r9); const listItem_r4 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateChartOptions(listItem_r4)); });
    i0.ɵɵtwoWayListener("ngModelChange", function ChartOptionsComponent_For_8_Conditional_2_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r9); const listItem_r4 = i0.ɵɵnextContext().$implicit; i0.ɵɵtwoWayBindingSet(listItem_r4.selected, $event) || (listItem_r4.selected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 12)(4, "span", 13);
    i0.ɵɵconditionalCreate(5, ChartOptionsComponent_For_8_Conditional_2_Conditional_5_Template, 4, 0);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3, listItem_r4.description));
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", listItem_r4.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", listItem_r4.label);
    i0.ɵɵadvance();
    i0.ɵɵconditional(listItem_r4.helpName ? 5 : -1);
} }
function ChartOptionsComponent_For_8_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
} }
function ChartOptionsComponent_For_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, ChartOptionsComponent_For_8_Conditional_0_Template, 1, 0, "div", 5);
    i0.ɵɵconditionalCreate(1, ChartOptionsComponent_For_8_Conditional_1_Template, 9, 6, "div", 8)(2, ChartOptionsComponent_For_8_Conditional_2_Template, 6, 6, "div");
    i0.ɵɵconditionalCreate(3, ChartOptionsComponent_For_8_Conditional_3_Template, 1, 0, "div", 5);
} if (rf & 2) {
    let tmp_13_0;
    const listItem_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(listItem_r4.dividerAbove ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_13_0 = listItem_r4.value === ctx_r2.FundChartOptionValue.CONVERT_CURRENCY && ctx_r2.currencyDropdownConfig()) ? 1 : 2, tmp_13_0);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(listItem_r4.dividerUnder ? 3 : -1);
} }
function ChartOptionsComponent_Conditional_10_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-multi-select-dropdown", 20);
    i0.ɵɵlistener("changeHandler", function ChartOptionsComponent_Conditional_10_Conditional_0_Template_ycn_multi_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.updateChartOptions($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dataInFooterConfig_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dropdownContainerClass", "dropdown-nested")("buttonClass", "dropdown-item")("dropdownItemClass", "pl-40")("config", dataInFooterConfig_r12);
} }
function ChartOptionsComponent_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, ChartOptionsComponent_Conditional_10_Conditional_0_Template, 1, 4, "ycn-multi-select-dropdown", 19);
} if (rf & 2) {
    i0.ɵɵconditional(ctx.list.length ? 0 : -1);
} }
function ChartOptionsComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-single-select-dropdown", 7);
    i0.ɵɵlistener("changeHandler", function ChartOptionsComponent_Conditional_11_Template_ycn_single_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateChartDataInLegend($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c2))("customLabel", "Data in Legend")("config", ctx);
} }
function ChartOptionsComponent_Conditional_13_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-single-select-dropdown", 7);
    i0.ɵɵlistener("changeHandler", function ChartOptionsComponent_Conditional_13_Template_ycn_single_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateChartValueFlags($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c2))("customLabel", "Value Flags")("config", ctx);
} }
function ChartOptionsComponent_Conditional_14_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "div", 5);
    i0.ɵɵelementStart(1, "ycn-single-select-dropdown", 7);
    i0.ɵɵlistener("changeHandler", function ChartOptionsComponent_Conditional_14_Template_ycn_single_select_dropdown_changeHandler_1_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateChartFrequency($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c2))("customLabel", "Period")("config", ctx);
} }
/**
 * Chart Options Component
 *
 * This component shows a list of chart options and checkboxes in dropdown. The checkboxes show whether
 * the corresponding item is currently selected. Below that, there is a nested single-select dropdown
 *  with options for how the name is displayed in the legend.
 *
 * Input Properties:
 *      chartOptionsConfig: Config for the main chart options dropdown
 *      nameInLegendOptionsConfig: Config for the nested "name in legend" options dropdown
 *      dataInLegendDropdownConfig: Config for the nested "data in legend" options dropdown
 *      frequencyOptionsConfig: Config for the nested "frequency" options dropdown
 *
 * Output Properties:
 *      closeHandler: EventEmitter that emits whenever the dropdown is closed
 *      chartOptionChangeHandler: EventEmitter that emits whenever a chart option is selected/deselected
 *      dataInLegendChangeHandler: emits when the selected "data in legend" option is changed
 *      nameInLegendChangeHandler: EventEmitter that emits whenever a "name in legend" option is changed
 *      frequencyChangeHandler: EventEmitter that emits whenever a "frequency" option is changed
 *
 * Internal Properties:
 *      isOpen: boolean for whether the dropdown is displaying the selectable items
 */
export class ChartOptionsComponent {
    constructor(dropdownHelperService) {
        this.dropdownHelperService = dropdownHelperService;
        this.chartOptionsConfig = input.required(...(ngDevMode ? [{ debugName: "chartOptionsConfig" }] : []));
        this.nameInLegendOptionsConfig = input.required(...(ngDevMode ? [{ debugName: "nameInLegendOptionsConfig" }] : []));
        this.dataInFooterDropdownConfig = input(...(ngDevMode ? [undefined, { debugName: "dataInFooterDropdownConfig" }] : []));
        this.dataInLegendDropdownConfig = input(...(ngDevMode ? [undefined, { debugName: "dataInLegendDropdownConfig" }] : []));
        this.valueFlagsDropdownConfig = input(...(ngDevMode ? [undefined, { debugName: "valueFlagsDropdownConfig" }] : []));
        this.currencyDropdownConfig = input(...(ngDevMode ? [undefined, { debugName: "currencyDropdownConfig" }] : []));
        this.frequencyOptionsConfig = input(...(ngDevMode ? [undefined, { debugName: "frequencyOptionsConfig" }] : []));
        this.chartOptionChangeHandler = new EventEmitter();
        this.nameInLegendChangeHandler = new EventEmitter();
        this.dataInLegendChangeHandler = new EventEmitter();
        this.valueFlagsChangeHandler = new EventEmitter();
        this.currencyChangeHandler = new EventEmitter();
        this.frequencyChangeHandler = new EventEmitter();
        this.closeHandler = new EventEmitter();
        this.el = viewChild.required('chartOptions');
        this.isOpen = false;
        this.isCurrencyMenuOpen = false;
        this.FundChartOptionValue = FundChartOptionValue;
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.isOpen) {
                this.toggle();
            }
        };
        this.dropdownHelperService.setCloseHandler(this.el().nativeElement, autoCloseHandler);
    }
    toggle() {
        if (this.isOpen) {
            this.isOpen = false;
            this.closeHandler.emit();
        }
        else {
            this.isOpen = true;
        }
    }
    updateChartOptions(newOption) {
        this.chartOptionChangeHandler.emit(newOption);
    }
    updateChartNameInLegend(newOption) {
        this.nameInLegendChangeHandler.emit(newOption);
    }
    updateChartFrequency(newOption) {
        this.frequencyChangeHandler.emit(newOption);
    }
    updateChartDataInLegend(newOption) {
        this.dataInLegendChangeHandler.emit(newOption);
    }
    updateChartValueFlags(newOption) {
        this.valueFlagsChangeHandler.emit(newOption);
    }
    updateChartCurrency(newOption) {
        // A currency only shows as selected while conversion is on.
        // Picking any unselected currency (including the saved currency while conversion is off) enables conversion.
        // No-ops when re-picking the same selected currency while currency conversion is on.
        if (newOption.type === 'divider' || !newOption.value || newOption.selected) {
            return;
        }
        this.currencyChangeHandler.emit(newOption.value);
    }
}
ChartOptionsComponent.ɵfac = function ChartOptionsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartOptionsComponent)(i0.ɵɵdirectiveInject(i1.DropdownHelperService)); };
ChartOptionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartOptionsComponent, selectors: [["ycn-chart-options"]], viewQuery: function ChartOptionsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.el, _c0, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
    } }, inputs: { chartOptionsConfig: [1, "chartOptionsConfig"], nameInLegendOptionsConfig: [1, "nameInLegendOptionsConfig"], dataInFooterDropdownConfig: [1, "dataInFooterDropdownConfig"], dataInLegendDropdownConfig: [1, "dataInLegendDropdownConfig"], valueFlagsDropdownConfig: [1, "valueFlagsDropdownConfig"], currencyDropdownConfig: [1, "currencyDropdownConfig"], frequencyOptionsConfig: [1, "frequencyOptionsConfig"] }, outputs: { chartOptionChangeHandler: "chartOptionChangeHandler", nameInLegendChangeHandler: "nameInLegendChangeHandler", dataInLegendChangeHandler: "dataInLegendChangeHandler", valueFlagsChangeHandler: "valueFlagsChangeHandler", currencyChangeHandler: "currencyChangeHandler", frequencyChangeHandler: "frequencyChangeHandler", closeHandler: "closeHandler" }, standalone: false, decls: 17, vars: 15, consts: [["chartOptions", ""], ["helpModal", ""], [1, "dropdown", 3, "ngClass"], [1, "btn", "btn-secondary", "btn-block", "dropdown-toggle", "user-select-none", 3, "click"], [1, "dropdown-menu", 3, "ngClass"], [1, "dropdown-divider"], [3, "customCssClasses", "customLabel", "config"], [3, "changeHandler", "customCssClasses", "customLabel", "config"], [1, "dropdown", "dropdown-nested"], [1, "dropdown", "dropdown-nested", 3, "mouseenter", "mouseleave"], [1, "custom-control", "custom-checkbox", "dropdown-item", "dropdown-toggle"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "textContent"], [1, "dropdown-menu", "dropdown-menu-scrollable-lg", 3, "ngClass"], [1, "help-toggler", 3, "click"], [1, "custom-control", "custom-checkbox", "dropdown-item", "custom-checkbox-style1"], ["type", "radio", "name", "fund-chart-currency", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control", "custom-checkbox", "dropdown-item", 3, "ngClass"], [3, "dropdownContainerClass", "buttonClass", "dropdownItemClass", "config"], [3, "changeHandler", "dropdownContainerClass", "buttonClass", "dropdownItemClass", "config"]], template: function ChartOptionsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2, 0)(2, "a", 3);
        i0.ɵɵlistener("click", function ChartOptionsComponent_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggle()); });
        i0.ɵɵelementStart(3, "span")(4, "span");
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵrepeaterCreate(7, ChartOptionsComponent_For_8_Template, 4, 3, null, null, _forTrack0);
        i0.ɵɵelement(9, "div", 5);
        i0.ɵɵconditionalCreate(10, ChartOptionsComponent_Conditional_10_Template, 1, 1);
        i0.ɵɵconditionalCreate(11, ChartOptionsComponent_Conditional_11_Template, 1, 4, "ycn-single-select-dropdown", 6);
        i0.ɵɵelementStart(12, "ycn-single-select-dropdown", 7);
        i0.ɵɵlistener("changeHandler", function ChartOptionsComponent_Template_ycn_single_select_dropdown_changeHandler_12_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updateChartNameInLegend($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(13, ChartOptionsComponent_Conditional_13_Template, 1, 4, "ycn-single-select-dropdown", 6);
        i0.ɵɵconditionalCreate(14, ChartOptionsComponent_Conditional_14_Template, 2, 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(15, "ycn-help-modal", null, 1);
    } if (rf & 2) {
        let tmp_6_0;
        let tmp_7_0;
        let tmp_11_0;
        let tmp_12_0;
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1, ctx.isOpen));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.chartOptionsConfig().title.label);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c1, ctx.isOpen));
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.chartOptionsConfig().list);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional((tmp_6_0 = ctx.dataInFooterDropdownConfig()) ? 10 : -1, tmp_6_0);
        i0.ɵɵadvance();
        i0.ɵɵconditional((tmp_7_0 = ctx.dataInLegendDropdownConfig()) ? 11 : -1, tmp_7_0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(14, _c2))("customLabel", "Name in Legend")("config", ctx.nameInLegendOptionsConfig());
        i0.ɵɵadvance();
        i0.ɵɵconditional((tmp_11_0 = ctx.valueFlagsDropdownConfig()) ? 13 : -1, tmp_11_0);
        i0.ɵɵadvance();
        i0.ɵɵconditional((tmp_12_0 = ctx.frequencyOptionsConfig()) ? 14 : -1, tmp_12_0);
    } }, dependencies: [i2.NgClass, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel, i4.HelpModalComponent, i5.MultiSelectDropdownComponent, i6.SingleSelectDropdownComponent], encapsulation: 2 });
